import React from 'react';
import { Thermometer, Wrench, Building2, ClipboardCheck } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  icon: Thermometer,
  title: 'Installation',
  description: 'Daikin and Mitsubishi specialists delivering bespoke commercial air conditioning installations nationwide. From single-split systems to large-scale VRV/VRF projects.'
}, {
  icon: Wrench,
  title: 'Maintenance',
  description: 'Planned preventative maintenance contracts with 6 and 12-month options. Every visit includes detailed photo reports and full compliance documentation.'
}, {
  icon: Building2,
  title: 'Facilities management',
  description: 'White-label and in-house FM support for landlords, property managers, and M&E contractors. Ad-hoc callouts and ongoing contracts available nationwide.'
}, {
  icon: ClipboardCheck,
  title: 'TM44 compliance',
  description: 'In-house TM44 energy efficiency inspections for systems over 12kW. Linked to ISO 14001 and required every 5 years for non-domestic buildings.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-[#E8F0F8]" data-id="element-292">
      <div className="container mx-auto px-6" data-id="element-293">
        <div className="grid md:grid-cols-2 gap-x-24 gap-y-0" data-id="element-294">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="py-12 border-b border-primary-dark/10 last:border-b-0 md:odd:border-r md:odd:pr-12 md:even:pl-12" data-id="element-295">
              <div className="flex items-start gap-6" data-id="element-296">
                <div className="flex-shrink-0" data-id="element-297">
                  <service.icon className="w-10 h-10 text-accent stroke-[1.5]" data-id="element-298" />
                </div>
                <div data-id="element-299">
                  <h3 className="text-3xl font-serif mb-4 text-primary-dark" data-id="element-300">
                    {service.title}
                  </h3>
                  <p className="text-primary-dark/70 leading-relaxed" data-id="element-301">
                    {service.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}